import { useState, useEffect } from 'react';
import { userPreferencesApi } from '../services/preferencesApi';

/** Module-level cache so we don't re-fetch on every visualizer mount. */
let cachedColors: Record<string, string> | null = null;

export function useUserRegionColors(): {
  userRegionColors: Record<string, string>;
  isLoading: boolean;
} {
  const [colors, setColors] = useState<Record<string, string>>(cachedColors ?? {});
  const [isLoading, setIsLoading] = useState(cachedColors === null);

  useEffect(() => {
    if (cachedColors !== null) return;

    let cancelled = false;

    userPreferencesApi
      .get()
      .then((data) => {
        if (cancelled) return;
        cachedColors = data.region_colors;
        setColors(data.region_colors);
      })
      .catch(() => {
        // Silently fall back to empty — the visualizer will use the positional defaults
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { userRegionColors: colors, isLoading };
}

/** Call this to invalidate the cache (e.g., after saving preferences). */
export function invalidateUserRegionColors(): void {
  cachedColors = null;
}
